import { BuiltinInstanceMemberValue } from '../../BuiltinInstanceMemberValue';
export class ArrayStorageLength extends BuiltinInstanceMemberValue {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.getArrayStorageLength);
        sb.emitHelper(node, options, sb.helpers.wrapNumber);
    }
}

//# sourceMappingURL=length.js.map
